import { Component, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GroupService } from '../../../services/groups-api.service';
import { LinkUsersComponent } from './link-users/link-users.component';

@Component({
  selector: 'tab-users',
  templateUrl: './tab-users.component.html',
  styleUrls: ['./tab-users.component.scss']
})
export class TabUsersComponent {
  @Input() public linkedUsers: FormArray;
  @Input() public isViewMode: boolean;
  @Input() public groupId: any;
  public readonly reload = new Subject<void>();

  public searchInputValue: FormControl;

  constructor(
    private matDialog: MatDialog
  ) {
    this.searchInputValue = new FormControl();
  }

  public linkUsers(): void {
    this.matDialog.open(LinkUsersComponent, {
        panelClass: ['dialog-groups'],
        data: this.groupId,
        hasBackdrop: false
      })
      .beforeClosed()
      .pipe(filter((result) => result && result.reload))
      .subscribe(() => {
        this.reload.next();
      });
  }
}

